import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";

interface User {
  id: string;
  email: string;
  name: string;
  role: "OWNER" | "ADMIN";
  smsCreditCents: number;
  emailVerifiedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  _count: { cats: number; orders: number };
}

export function AdminUsersPage() {
  const qc = useQueryClient();
  const [search, setSearch] = useState("");
  const q = useQuery({
    queryKey: ["admin-users", search],
    queryFn: () => api<User[]>(`/api/admin/users${search ? `?search=${encodeURIComponent(search)}` : ""}`),
  });

  const adjust = useMutation({
    mutationFn: ({ id, cents }: { id: string; cents: number }) =>
      api(`/api/admin/users/${id}`, {
        method: "PATCH",
        body: JSON.stringify({ smsCreditAdjustCents: cents }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["admin-users"] }),
  });

  return (
    <div>
      <h1 className="font-display text-3xl font-semibold tracking-tight mb-4">Nutzer</h1>
      <input
        className="input mb-4 max-w-sm"
        placeholder="Suche E-Mail oder Name"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-left">
            <tr>
              <th className="p-3">E-Mail</th>
              <th className="p-3">Name</th>
              <th className="p-3">Rolle</th>
              <th className="p-3">Haustiere</th>
              <th className="p-3">Bestellungen</th>
              <th className="p-3">SMS-Guthaben</th>
              <th className="p-3">Status</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {q.data?.map((u) => (
              <tr key={u.id} className="border-t border-slate-100">
                <td className="p-3">{u.email}</td>
                <td className="p-3">{u.name}</td>
                <td className="p-3">{u.role}</td>
                <td className="p-3">{u._count.cats}</td>
                <td className="p-3">{u._count.orders}</td>
                <td className="p-3">{(u.smsCreditCents / 100).toFixed(2)} €</td>
                <td className="p-3">
                  {u.deletedAt ? "gelöscht" : u.emailVerifiedAt ? "verifiziert" : "unverifiziert"}
                </td>
                <td className="p-3">
                  <button
                    className="text-xs underline"
                    onClick={() => {
                      const input = prompt("Betrag in Cent (+ oder -):", "500");
                      const cents = Number(input);
                      if (Number.isFinite(cents) && cents !== 0) adjust.mutate({ id: u.id, cents });
                    }}
                  >
                    Guthaben anpassen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
